import { setBlockType } from 'prosemirror-commands';
import { Dropdown, MenuItem } from 'prosemirror-menu';
import { NodeType, Schema } from 'prosemirror-model';

const blockTypeItem = (nodeType: NodeType, options) => {
  const run = setBlockType(nodeType, options.attrs);

  const active = state => {
    const { $from, to, node } = state.selection as any;
    if (node) {
      return node.hasMarkup(nodeType, options.attrs);
    }

    return to <= $from.end() && $from.parent.hasMarkup(nodeType, options.attrs);
  };

  const enable = state => active(state) || run(state);

  return new MenuItem({
    ...options,
    run,
    active,
    enable,
  });
};

export function styleMenu(schema: Schema) {
  return [
    new Dropdown(
      [
        blockTypeItem(schema.nodes.heading, {
          title: 'Change to heading',
          label: 'Heading',
          class: 'heading-1',
          attrs: { level: 1 },
        }),
        blockTypeItem(schema.nodes.heading, {
          title: 'Change to sub-heading',
          label: 'Heading 2',
          class: 'heading-2',
          attrs: { level: 2 },
        }),
        blockTypeItem(schema.nodes.heading, {
          title: 'Change to section title',
          label: 'Heading 3',
          class: 'heading-3',
          attrs: { level: 3 },
        }),
        blockTypeItem(schema.nodes.paragraph, {
          title: 'Change to paragraph style',
          label: 'Paragraph',
        }),
      ],
      { label: ' ', class: 'ProseMirror-icon-style' },
    ) as MenuItem,
  ];
}
